import { AppServiceId } from '../../config/build';

export type SettingsTabId = 'account' | 'settings' | 'users' | 'resources' | 'permissions' | 'services' | 'licenses' | 'thirdparty';

export interface SettingsNavTab {
  id: SettingsTabId;
  label: string;
  description: string;
}

export const settingsTabs: SettingsNavTab[] = [
  {
    id: 'settings',
    label: 'General Settings',
    description: 'Overall platform preferences and defaults.',
  },
  {
    id: 'account',
    label: 'Account Settings',
    description: 'Manage your profile access and password.',
  },
  {
    id: 'users',
    label: 'User Management',
    description: 'Invite users, assign roles and reset access.',
  },
  {
    id: 'resources',
    label: 'Resources',
    description: 'Browse platform sources and targets by transport type.',
  },
  {
    id: 'permissions',
    label: 'Permissions',
    description: 'Control capabilities and feature level access.',
  },
  {
    id: 'services',
    label: 'Services',
    description: 'Fine-tune behaviour per media service.',
  },
  {
    id: 'licenses',
    label: 'Licenses',
    description: 'Track entitlement keys and host binding.',
  },
  {
    id: 'thirdparty',
    label: 'Thirdparty',
    description: 'Configure external service integrations.',
  },
];

export type ServiceTabId = 'onegui' | 'watchfolder' | 'fileQueuer' | 'ingest' | 'recorder' | 'complianceRecord';

export const serviceTabOrder: ServiceTabId[] = ['onegui', 'watchfolder', 'fileQueuer', 'ingest', 'recorder', 'complianceRecord'];
export const defaultServiceTab: ServiceTabId = serviceTabOrder[0];

export const settingsServiceMap: Record<ServiceTabId, AppServiceId> = {
  onegui: 'oneGUI',
  watchfolder: 'watchfolder',
  fileQueuer: 'fileQueuer',
  ingest: 'ingest',
  recorder: 'recorder',
  complianceRecord: 'complianceRecord',
};
